import { render, staticRenderFns } from "./PorCategoriaMunicipal.vue?vue&type=template&id=52dfe192&scoped=true"
import script from "./PorCategoriaMunicipal.vue?vue&type=script&lang=js"
export * from "./PorCategoriaMunicipal.vue?vue&type=script&lang=js"
import style0 from "./PorCategoriaMunicipal.vue?vue&type=style&index=0&id=52dfe192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dfe192",
  null
  
)

export default component.exports